import style from './Field.module.scss';

import { FieldTitle, FieldTitleTheme } from '@components/FieldTitle';

interface FieldProps {
    title: string;
    value: number | string | React.ReactElement<any>;
}

export function Field({ title, value }: FieldProps): React.ReactElement<any> {
    return (
        <div className={style.field}>
            <FieldTitle
                theme={FieldTitleTheme.WithFlex}
                title={title}
            />
            <div>{value}</div>
        </div>
    );
}
